'use client'

import { useLayoutEffect, useRef } from 'react'

// Shared by the directory and brand docks. Floating controls and page rails
// can clear the actual tray height as selections wrap or the viewport changes.
export const useCompareDockHeight = <T extends HTMLElement>(count: number) => {
  const ref = useRef<T>(null)
  useLayoutEffect(() => {
    const root = document.documentElement
    const property = '--compare-dock-h'
    const element = ref.current
    if (!element) {
      root.style.removeProperty(property)
      return
    }
    const update = () => root.style.setProperty(property, `${element.getBoundingClientRect().height}px`)
    update()
    const observer = new ResizeObserver(update)
    observer.observe(element)
    return () => {
      observer.disconnect()
      root.style.removeProperty(property)
    }
  }, [count])
  return ref
}
